import module from 'module';
import { tick } from '../utils';
import Spaces from '../spacesLib';

let previewTokens = {};
let previewTokensCnt = 0;
let previewTokensTimer = false;
let observerItems = [];
let observer;

async function initObserver() {
	if (observer)
		return;

	if (!window.IntersectionObserver) {
		await import("intersection-observer");
		IntersectionObserver.prototype.USE_MUTATION_OBSERVER = false;
	}

	observer = new IntersectionObserver(intersectionCallback, {
		root:			null,
		rootMargin:		'0px',
		threshold:		0.0,
	});

	for (let item of observerItems)
		observer.observe(item);
}

function init() {
	// js-pvt - preview view tracker
	for (let item of document.querySelectorAll('.js-pvt')) {
		item.classList.remove('js-pvt');
		if (observer)
			observer.observe(item);
		observerItems.push(item);
	}
}

export function loadLazyItem(el) {
	if (el.tagName == "IMG") {
		if (el.dataset.s) {
			if (el.dataset.s2)
				el.srcset = el.dataset.s + ', ' + el.dataset.s2 + ' 1.5x';
			el.src = el.dataset.s;
			delete el.dataset.s;
			delete el.dataset.s2;
		}
	}
}

function intersectionCallback(entries) {
	for (let item of entries) {
		if (item.intersectionRatio > 0) {
			trackItemView(item.target);
			observer.unobserve(item.target);
			observerItems = observerItems.filter((observerItem) => observerItem !== item.target);
		}
	}
}

function sendPreviewTokens() {
	if (!previewTokensCnt) {
		previewTokensTimer = false;
		return;
	}

	let apiData = previewTokens;
	apiData.CK = null;
	apiData.page = location.href;

	previewTokens = {};
	previewTokensCnt = 0;

	Spaces.api("uobj.view", apiData, function (res) {
		tick(sendPreviewTokens);
		if (res.code != 0)
			console.error('[views tracker] ' + Spaces.apiError(res));
	}, {
		onError: function (err) {
			tick(sendPreviewTokens);
			console.error('[views tracker] ' + err);
		}
	});
}

function trackItemView(el) {
	let token = el.dataset.t;
	if (!token)
		return;

	let parts = token.split('!'),
	id = parts[0],
	type = 'toKens_' + (parts[1] || "preview");

	(previewTokens[type] || (previewTokens[type] = [])).push(id);
	previewTokensCnt++;

	if (!previewTokensTimer)
		previewTokensTimer = setTimeout(sendPreviewTokens, 5000);

	delete el.dataset.t;
}

function destroy() {
	for (let observerItem of observerItems) {
		observer && observer.unobserve(observerItem);
		observerItem.classList.add('js-pvt');
	}

	if (observerItems.length > 0) {
		tick(() => init());
		observerItems = [];
	}

	if (observer) {
		observer.disconnect();
		observer = null;
	}
}

module.on("component", init);
module.on("componentpage", initObserver);
module.on("componentpagedone", destroy);

export { trackItemView };
